import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isAuthenticated, getUserPrivileges, getUserRole } from '../utils/auth';

const PrivateRoute = ({ element, allowedRoles = [], anyOf = [] }) => {
  const [showPopup, setShowPopup] = useState(false);
  const token = isAuthenticated();
  const role = getUserRole();
  const privileges = getUserPrivileges();
  const userPrivilegeKey = privileges.join("|");
  const allowedRoleKey = allowedRoles.join("|");
  const requiredPrivilegeKey = anyOf.join("|");
  const location = useLocation();
  const navigate = useNavigate();

  // console.log("Token Exists:", token);
  // console.log("User Role:", role);
  // console.log("Allowed Roles for this Page:", allowedRoles);

  useEffect(() => {
    const roleRules = allowedRoleKey ? allowedRoleKey.split("|") : [];
    const privilegeRules = requiredPrivilegeKey ? requiredPrivilegeKey.split("|") : [];
    const userPrivilegeRules = userPrivilegeKey ? userPrivilegeKey.split("|") : [];
    const hasAllowedRole = roleRules.includes(role);
    const hasRequiredPrivilege = privilegeRules.some((privilege) => userPrivilegeRules.includes(privilege));
    const canAccess = role === "admin" || hasAllowedRole || hasRequiredPrivilege;

    if (!token) {
      navigate("/login"); // Redirect if not logged in
    } else if (!canAccess) {
      localStorage.setItem("lastAllowedPage", location.pathname);
      setShowPopup(true);
    }
  }, [token, role, userPrivilegeKey, allowedRoleKey, requiredPrivilegeKey, navigate, location]);

  const handleGoBack = () => {
    setShowPopup(false);

    // Try to go back using browser history
    if (window.history.length > 1) {
      window.history.back();  // Simulates the browser's back button
    } else {
      const lastPage = localStorage.getItem("lastAllowedPage") || "/dashboard";
      navigate(lastPage, { replace: true });  // Redirect if no history available
    }
  };

  if (showPopup) {
    return (
      <div style={styles.popupOverlay}>
        <div style={styles.popup}>
          <h2>Access Denied</h2>
          <p>You do not have permission to view this page.</p>
          <button onClick={handleGoBack} style={styles.button}>Go Back</button>
        </div>
      </div>
    );
  }

  return element;
};

const styles = {
  popupOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  popup: {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "8px",
    textAlign: "center",
    width: "300px",
  },
  button: {
    marginTop: "10px",
    padding: "10px 20px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default PrivateRoute;
